var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',[_vm._v(_vm._s(_vm.title))]),_c('apexchart',{attrs:{"type":"bar","options":_vm.options,"height":"500","series":_vm.options.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }